export class IndexError extends Error {}
